import { renderPc, renderMobileDeal } from "./DrawingIntergrated";
import SeenSeenDeal from "./SeenSeenDeal.js";
import CombinedDeliveryDeals from "./CombinedDeliveryDeals.js";
import { sendCPCLog } from "../../utils/common";
import SuperClickDeal from "./SuperClickDeal";
import PlanBestDeal from "./PlanBestDeal";
import IntergratedPaginate from "./IntergratedPaginate";
import * as cpcUtil from "./cpcUtil.js";

/**
 * 상단 광고상품영역
 */
export default class IntergratedDeals {
  constructor() {
    if (TMON.oApp.sPlatform === "PW") {
      this.fetchDeals();
    } else {
      this.setIoApi();
    }
  }

  renderInfo() {
    /* 본본 상품 Render 정보 */
    const seenSeenRenderInfo = new SeenSeenDeal().getSeenRenderInfo();
    /* 묶음 상품 Render 정보 */
    const combineRenderInfo = new CombinedDeliveryDeals().getCombineInfo();

    return { combineRenderInfo, seenSeenRenderInfo };
  }

  renderOnPc() {
    let sRenderUi = "default";
    const { combineRenderInfo, seenSeenRenderInfo } = this.renderInfo();

    if (combineRenderInfo.dataSize) {
      sRenderUi = "COMBINED_DELIVERY_DEALS"; // 묶음상품 딜리스트
    }
    if (sRenderUi === "COMBINED_DELIVERY_DEALS") {
      /* 묶음상품만 */
      this.sHtmlOnTop += renderPc(combineRenderInfo);
    } else if (sRenderUi === "default") {
      if (seenSeenRenderInfo.dataSize) {
        /* 본본 상품만 있을 경우 */
        this.sHtmlOnTop += renderPc(seenSeenRenderInfo);
      }
    }
    $("[data-role=intergratedTop]").html(this.sHtmlOnTop);
  }

  renderOnMobile() {
    const { combineRenderInfo, seenSeenRenderInfo } = this.renderInfo();
    renderMobileDeal(combineRenderInfo);
    renderMobileDeal(seenSeenRenderInfo);

    const scrollContainer = document.querySelector(
      'div[data-role="_wrapRecommendDealContainer"] .deallist_scroll_inner'
    );
    const anchors = [...scrollContainer.querySelectorAll("ul > li > a")];
    cpcUtil.onFirstLoad(anchors.slice(0, 4), "CPC_AI");
    cpcUtil.onScrollEnd(scrollContainer, "CPC_AI");
  }

  setEvent() {
    const welSeenSeenDealContainer = $(
      "[data-role=_wrapRecommendDealContainer]"
    );
    if (welSeenSeenDealContainer.length === 0) return;

    const welSeenSeenDealAnchors = welSeenSeenDealContainer.find(
      'a[data-ad="true"]'
    );
    welSeenSeenDealAnchors.on("click", (e) => {
      sendCPCLog([e.currentTarget], "CLICK", "CPC_AI");
    });

    if (TMON.sDevice === "PW") {
      const welSeenSeenAdInfoLayers = welSeenSeenDealContainer.find(
        ".lyr_info"
      );
      welSeenSeenAdInfoLayers.on("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.currentTarget.classList.toggle("on");
      });
    } else {
      const toggleTooltip = (e) => {
        e.preventDefault();
        e.currentTarget.parentNode.classList.toggle("on");
      };
      const welSeenSeenAdInfoBtns = welSeenSeenDealContainer.find(".ad_info");
      const welSeenSeenAdInfoLayers = welSeenSeenDealContainer.find(".ad_desc");
      welSeenSeenAdInfoLayers.on("click", toggleTooltip);
      welSeenSeenAdInfoBtns.on("click", toggleTooltip);
    }
  }

  setIoApi() {
    // 모바일에선 상품설명 영역이 노출될 때 intergratedDeals을 조회한다.
    const target =
      TMON.view_mode === "app"
        ? document.querySelector(".space_bottom")
        : document.getElementById("footer");

    const io = new IntersectionObserver((entries, observer) => {
      const filtered = entries.filter((entry) => entry.isIntersecting)[0];
      if (!filtered) return;

      this.fetchDeals();
      observer.unobserve(filtered.target);
    });
    io.observe(target);
  }

  async fetchDeals() {
    await TMON.oApp.oApi.fetchApi("intergratedDeals");
    if (
      !TMON.oApp.htStorage.intergratedDeals ||
      !TMON.oApp.htStorage.intergratedDeals.data
    ) {
      return;
    }

    this.sHtmlOnTop = "";
    if (TMON.oApp.sPlatform === "PW") {
      // PC 에서만 각 연관딜 영역을 JS 에서 렌더링한다.
      this.renderOnPc();
    } else {
      this.renderOnMobile();
    }
    this.setEvent();

    new SuperClickDeal();
    new PlanBestDeal();
    if (TMON.oApp.sPlatform === "PW") {
      TMON.oApp.oIntergratedPaginate = new IntergratedPaginate();
    }
  }
}
